// extracted by mini-css-extract-plugin
module.exports = {"container":"lQ-z","copyContainer":"mQ-z"};